import { defineStore } from 'pinia'

export const useSupplierStore = defineStore({
    id: 'supplier',
    state: () => ({
        suppliers: null,
    }),
    actions: {
        async setSuppliers() {
            this.suppliers = await this.$nuxt.$axios.$get('api/xero/suppliers')
        },
    },
    getters: {
        fetchSuppliers() {
            return this.suppliers.map(x => {
                const invoices = x.invoices.map(invoice => {
                    return { ...invoice, isSelected: false }
                })
                return { ...x, invoices }
            })
        },
    },
})
